<div class="popup popup-basic" class="deal__details" *ngIf="control.hasDealDetails === false">
  <div class="popup-body deal__details__body" fxLayout="row wrap">
    <div fxFlexFill>Loading...</div>
  </div>
</div>

<div class="popup popup-basic" class="deal__details" *ngIf="control.hasDealDetails === true">
  <div
    class="deal__details__top__summary__wrapper"
    [class.buy]="intentType == OI.BUY"
    [class.sell]="intentType == OI.SELL"
    [ngStyle]="{'display': control.hasDealDetails && summary ? 'block' : 'none'}"
  >
    {{summary}}
  </div>
  <div class="divider"></div>
  <div
    class="popup-body deal__details__body"
    [ngClass]="{'deal__details__top__panel_expand' : control.ndfEnabled || control.isBmark, 'deal__details__top__panel' : !control.ndfEnabled && !control.isBmark }"
    fxLayout="row"
  >
    <div styleClass="deal__details__body__fieldset" fxFlex="1 1 50.00%">
      <p-overlayPanel #infoAccount styleClass="order__details__overlay" appendTo="body">
        <div fxLayout="row ">
          <div class="order__details__body__label">Account Name</div>
          <div class="order__details__body__value">{{dealDetails.accountName}}</div>
        </div>
        <div fxLayout="row ">
          <div class="order__details__body__label">Account Booking Code</div>
          <div class="order__details__body__value">{{dealDetails.accountBookingCd}}</div>
        </div>
        <div fxLayout="row ">
          <div class="order__details__body__label">Contact</div>
          <div class="order__details__body__value">{{dealDetails.accountContact}}</div>
        </div>
      </p-overlayPanel>
      <div fxLayout="row wrap" class="deal__details__client_id">
        <div fxFlex="0 0 100px" class="deal__details__body__label">Trade ID</div>
        <div fxFlex="1 1 calc(100% - 116px)" class="deal__details__body__value">
          {{BfxConfigIDRefHelper.getDealRef(dealDetails)}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div fxLayout="row wrap" class="deal__details__account_id">
        <div fxFlex="0 0 100px" class="deal__details__body__label">Order ID</div>
        <div fxFlex="1 1 calc(100% - 116px)" class="deal__details__body__value">
          {{BfxConfigIDRefHelper.getOrderRef(dealDetails)}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div fxLayout="row wrap" class="deal__details__client_id">
        <div fxFlex="0 0 100px" class="deal__details__body__label">Client ID</div>
        <div fxFlex="1 1 calc(100% - 116px)" class="deal__details__body__value">
          {{dealDetails.clientId}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div fxLayout="row wrap" class="deal__details__account_id">
        <div fxFlex="0 0 100px" class="deal__details__body__label">Account ID</div>
        <div fxFlex="1 1 calc(100% - 116px)" class="deal__details__body__value">
          {{dealDetails.accountId}}
        </div>
        <div
          class="deal__details__body__infobox"
          [appendTo]="isDesktop ? 'target' : 'body'"
          [hidden]="!dealDetails.accountId"
          (mouseenter)="infoAccount.toggle($event)"
          (mouseleave)="infoAccount.toggle($event)"
        >
          i
        </div>
      </div>
      <div fxLayout="row wrap" class="deal__details__instrument">
        <div fxFlex="0 0 100px" class="deal__details__body__label">Instrument</div>
        <div fxFlex="1 1 calc(100% - 116px)" class="deal__details__body__value">
          {{dealDetails.instrument}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div fxLayout="row wrap" class="deal__details__dir">
        <div fxFlex="0 0 100px" class="deal__details__body__label">Dir</div>
        <div fxFlex="1 1 calc(100% - 116px)" class="deal__details__body__value">
          {{dealDetails.dealDirStr}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div fxLayout="row wrap" class="deal__details__orderAmt">
        <div fxFlex="0 0 100px" class="deal__details__body__label">Fill Amt</div>
        <div fxFlex="1 1 calc(100% - 116px)" class="deal__details__body__value">
          {{dealDetails.dealtAmtStr+" "+dealDetails.dealtCcy}}
        </div>
        <div
          class="deal__details__body__infobox--usd"
          [appendTo]="isDesktop ? 'target' : 'body'"
          bfxTooltip="{{dealDetails.dealtAmtUsdStr}} USD"
          tooltipPosition="left"
        >
          $
        </div>
      </div>
      <div fxLayout="row wrap" class="deal__details__value_date">
        <div fxFlex="0 0 100px" class="deal__details__body__label">Value Date</div>
        <div fxFlex="1 1 calc(100% - 116px)" class="deal__details__body__value">
          {{control.isBmark ? dealDetails.bmarkValueDateTenor :
          formatUTCDate(dealDetails.valueDate)}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div fxLayout="row wrap" class="deal__details__value_date" *ngIf="control.ndfEnabled">
        <div fxFlex="0 0 100px" class="deal__details__body__label">Fixing Date</div>
        <div fxFlex="1 1 calc(100% - 116px)" class="deal__details__body__value">
          {{ formatUTCDate(dealDetails.fixingDate)}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div fxLayout="row wrap" class="deal__details__value_date" *ngIf="control.isBmark">
        <div fxFlex="0 0 100px" class="deal__details__body__label">Fixing Date</div>
        <div fxFlex="1 1 calc(100% - 116px)" class="deal__details__body__value">
          {{dealDetails.bmarkFixingDateTime}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div *ngIf="oboEnabled" fxLayout="row wrap" class="deal__details__obo_client">
        <div fxFlex="0 0 100px" class="deal__details__body__label">OBO Client</div>
        <div
          fxFlex="1 1 calc(100% - 116px)"
          class="deal__details__body__value"
          title="{{dealDetails.oboClient}}"
        >
          {{dealDetails.oboClient}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <!-- Custom Fields - first column -->
      <div *ngIf="customFieldsEnabled()">
        <div fxLayout="row wrap" *ngIf="customFieldEnabled(0)" class="deal__details__custom_field">
          <div
            fxFlex="0 0 100px"
            class="deal__details__custom_field__label"
            [appendTo]="desktop ? 'target' : 'body'"
            bfxTooltip="{{customFieldHeading(0)}}"
            tooltipPosition="top"
          >
            {{customFieldHeading(0)}}
          </div>
          <div
            fxFlex="1 1 calc(100% - 116px)"
            class="deal__details__body__value"
            [appendTo]="desktop ? 'target' : 'body'"
            bfxTooltip="{{customFieldValue(0)}}"
            tooltipPosition="top"
          >
            {{ customFieldValue(0) }}
          </div>
          <div class="deal__details__body__infobox--placeholder"></div>
        </div>
        <div fxLayout="row wrap" *ngIf="customFieldEnabled(2)" class="deal__details__custom_field">
          <div
            fxFlex="0 0 100px"
            class="deal__details__custom_field__label"
            [appendTo]="desktop ? 'target' : 'body'"
            bfxTooltip="{{customFieldHeading(2)}}"
            tooltipPosition="top"
          >
            {{customFieldHeading(2)}}
          </div>
          <div
            fxFlex="1 1 calc(100% - 116px)"
            class="deal__details__body__value"
            [appendTo]="desktop ? 'target' : 'body'"
            bfxTooltip="{{customFieldValue(2)}}"
            tooltipPosition="top"
          >
            {{ customFieldValue(2) }}
          </div>
          <div class="deal__details__body__infobox--placeholder"></div>
        </div>
      </div>
    </div>
    <div class="divider-vertical"></div>
    <div styleClass="deal__details__body__fieldset" fxFlex="1 1 50.00%">
      <div fxLayout="row wrap" class="deal__details__fill_user">
        <div fxFlex="0 0 130px" class="deal__details__body__label">Fill User</div>
        <div
          fxFlex="1 1 calc(100% - 146px)"
          *ngIf="displayFillUser"
          class="deal__details__body__value"
        >
          {{dealDetails.fillUserName}}
        </div>
        <div
          fxFlex="1 1 calc(100% - 146px)"
          *ngIf="!displayFillUser"
          class="deal__details__body__value"
        >
          {{dealDetails.fillUserCode}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div fxLayout="row wrap" class="deal__details__fill_date">
        <div fxFlex="0 0 130px" class="deal__details__body__label">Fill Time</div>
        <div fxFlex="1 1 calc(100% - 148px)" class="deal__details__body__value">
          {{dealDetails.creationDate | bfxMoment:'DD-MMM-YY HH:mm:ss.SSS'}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div fxLayout="row wrap" class="deal__details__trigger_time">
        <div fxFlex="0 0 130px" class="deal__details__body__label">Trigger Time</div>
        <div fxFlex="1 1 calc(100% - 146px)" class="deal__details__body__value">
          {{dealDetails.triggerTime | bfxMoment:'DD-MMM-YY HH:mm:ss.SSS'}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div fxLayout="row wrap" class="deal__details__trigger_rate">
        <div fxFlex="0 0 130px" class="deal__details__body__label">Trigger Rate</div>
        <div fxFlex="1 1 calc(100% - 146px)" class="deal__details__body__value">
          {{dealDetails.triggerRate}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div fxLayout="row wrap" class="deal__details__market_rate">
        <div fxFlex="0 0 130px" class="deal__details__body__label">Market Rate &#64; Fill</div>
        <div fxFlex="1 1 calc(100% - 146px)" class="deal__details__body__value">
          {{dealDetails.marketRateAtFill}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div fxLayout="row wrap" class="deal__details__deal_state">
        <div fxFlex="0 0 130px" class="deal__details__body__label">Deal State</div>
        <div fxFlex="1 1 calc(100% - 146px)" class="deal__details__body__value">
          {{dealDetails.dealStateName}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div fxLayout="row wrap" class="deal__details__hold_stp">
        <div fxFlex="0 0 130px" class="deal__details__body__label">Hold STP</div>
        <div fxFlex="1 1 calc(100% - 146px)" class="deal__details__body__value">
          {{(dealDetails.holdStp) ? 'Yes' : 'No'}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div fxLayout="row wrap" class="deal__details__fill_comment">
        <div fxFlex="0 0 130px" class="deal__details__body__label">Fill Comment</div>
        <div
          fxFlex="1 1 calc(100% - 146px)"
          class="deal__details__body__value"
          bfxTooltip="{{dealDetails.fillComment}}"
          appendTo="body"
          tooltipPosition="top"
          tooltipStyleClass="fill__comment__tooltip"
        >
          {{dealDetails.fillComment}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div
        fxLayout="row wrap"
        class="deal__details__value_date"
        *ngIf="control.ndfEnabled || control.isBmark"
      >
        <div fxFlex="0 0 130px" class="deal__details__body__label">Fixing Code</div>
        <div fxFlex="1 1 calc(100% - 146px)" class="deal__details__body__value">
          {{dealDetails.fixingCode}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div fxLayout="row wrap" class="deal__details__last_market">
        <div fxFlex="0 0 130px" class="deal__details__body__label">Last Market</div>
        <div fxFlex="1 1 calc(100% - 146px)" class="deal__details__body__value">
          {{dealDetails.lastMkt}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <div *ngIf="oboEnabled" fxLayout="row wrap" class="deal__details__obo_account">
        <div fxFlex="0 0 130px" class="deal__details__body__label">OBO Account</div>
        <div
          fxFlex="1 1 calc(100% - 146px)"
          class="deal__details__body__value"
          title="{{dealDetails.oboAccount}}"
        >
          {{dealDetails.oboAccount}}
        </div>
        <div class="deal__details__body__infobox--placeholder"></div>
      </div>
      <!-- Custom Fields - second column -->
      <div *ngIf="customFieldsEnabled()">
        <div fxLayout="row wrap" *ngIf="customFieldEnabled(1)" class="deal__details__custom_field">
          <div
            fxFlex="0 0 130px"
            class="deal__details__custom_field__label"
            [appendTo]="desktop ? 'target' : 'body'"
            bfxTooltip="{{customFieldHeading(1)}}"
            tooltipPosition="top"
          >
            {{customFieldHeading(1)}}
          </div>
          <div
            fxFlex="1 1 calc(100% - 146px)"
            class="deal__details__body__value"
            [appendTo]="desktop ? 'target' : 'body'"
            bfxTooltip="{{customFieldValue(1)}}"
            tooltipPosition="top"
          >
            {{ customFieldValue(1) }}
          </div>
          <div class="deal__details__body__infobox--placeholder"></div>
        </div>
        <div fxLayout="row wrap" *ngIf="customFieldEnabled(3)" class="deal__details__custom_field">
          <div
            fxFlex="0 0 130px"
            class="deal__details__custom_field__label"
            [appendTo]="desktop ? 'target' : 'body'"
            bfxTooltip="{{customFieldHeading(3)}}"
            tooltipPosition="top"
          >
            {{customFieldHeading(3)}}
          </div>
          <div
            fxFlex="1 1 calc(100% - 146px)"
            class="deal__details__body__value"
            [appendTo]="desktop ? 'target' : 'body'"
            bfxTooltip="{{customFieldValue(3)}}"
            tooltipPosition="top"
          >
            {{ customFieldValue(3) }}
          </div>
          <div class="deal__details__body__infobox--placeholder"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="divider"></div>
  <div class="popup-body deal__details__body deal__details_bottom_panel">
    <p-tabView
      fxFlex="1 1 100%"
      fxLayout="row wrap"
      styleClass="bfx-tabview deal__details__body__tab_view"
    >
      <p-tabPanel header="Trade Rates">
        <!-- <div fxLayout="row wrap"> -->
        <p-dataTable
          #tradeRates
          [value]="dealDetails.tradeRates"
          rowGroupMode="rowspan"
          sortField="grouping"
          groupField="groupingStr"
          [sortableRowGroup]="false"
          scrollHeight="105px"
          [scrollable]="true"
          resizableColumns="true"
          reorderableColumns="false"
        >
          <!-- <ng-template pTemplate="rowgroupheader" let-rowData>{{rowData['groupingStr']}}</ng-template> -->
          <p-column header="" styleClass="columnStyle" [style]="{'width':'90px'}" field="grouping">
            <ng-template let-col let-row="rowData" pTemplate="body">
              <div class="rowStyle" title="{{row['groupingStr']}}">{{row['groupingStr']}}</div>
            </ng-template>
          </p-column>
          <p-column
            field="instrument"
            header="Instrument"
            styleClass="columnStyle"
            [style]="{'width':'100px'}"
          >
            <ng-template let-col let-row="rowData" pTemplate="body">
              <div class="rowStyle Instrument" title="{{row[col.field]}}">{{row[col.field]}}</div>
            </ng-template>
          </p-column>
          <p-column
            field="spotRate"
            header="Spot"
            styleClass="columnStyle"
            [style]="{'width':'100px','min-width':'100px','text-align':'center'}"
          >
            <ng-template let-col let-row="rowData" pTemplate="body">
              <div class="rowStyle Spot" title="{{row[col.field]}}">{{row[col.field]}}</div>
            </ng-template>
          </p-column>
          <p-column
            field="fwdPts"
            header="Fwd Pts"
            styleClass="columnStyle"
            [style]="{'width':'100px','text-align':'center'}"
          >
            <ng-template let-col let-row="rowData" pTemplate="body">
              <div class="rowStyle Fwd-Pts" title="{{row[col.field]}}">{{row[col.field]}}</div>
            </ng-template>
          </p-column>
          <p-column
            field="allIn"
            header="All-In"
            styleClass="columnStyle"
            [style]="{'width':'100px','text-align':'center'}"
          >
            <ng-template let-col let-row="rowData" pTemplate="body">
              <div class="rowStyle All-In" title="{{row[col.field]}}">{{row[col.field]}}</div>
            </ng-template>
          </p-column>
          <p-column
            field="localBook"
            header="Local Book"
            styleClass="columnStyle"
            [style]="{'width':'100px','text-align':'center'}"
          >
            <ng-template let-col let-row="rowData" pTemplate="body">
              <div class="rowStyle Local-Book" title="{{row[col.field]}}">{{row[col.field]}}</div>
            </ng-template>
          </p-column>
          <p-column
            field="remoteBook"
            header="Remote Book"
            styleClass="columnStyle"
            [style]="{'width':'100px', 'text-align':'center'}"
          >
            <ng-template let-col let-row="rowData" pTemplate="body">
              <div class="rowStyle Remote-Book" title="{{row[col.field]}}">{{row[col.field]}}</div>
            </ng-template>
          </p-column>
        </p-dataTable>
        <!-- </div> -->
      </p-tabPanel>
      <p-tabPanel header="Deal Confirmations">
        <div class="deal__details__manual_deal_ref_row">
          <div styleClass="deal__details__manual_deal_ref" fxFlex>
            <div fxFlex fxLayout="row wrap">
              <div fxFlex="1 1 100px" class="deal__details__body__label">Manual Deal Ref</div>
              <div class="deal__details__body__value">{{dealDetails.manualDealRef ?? '-'}}</div>
            </div>
          </div>
        </div>
        <div>
          <p-dataTable
            [value]="dealDetails.dealConfirmations"
            resizableColumns="false"
            reorderableColumns="false"
            [scrollable]="true"
            scrollHeight="90px"
          >
            <p-column
              field="bookingUTI"
              header="Booking UTI"
              styleClass="columnStyle"
              [style]="{'width':'240px'}"
            >
              <ng-template let-col let-row="rowData" pTemplate="body">
                <div class="rowStyle" title="{{row[col.field]}}">{{row[col.field]}}</div>
              </ng-template>
            </p-column>
            <p-column
              field="descriptor"
              header="Deal Descriptor"
              styleClass="columnStyle"
              [style]="{'width':'320px'}"
            >
              <ng-template let-col let-row="rowData" pTemplate="body">
                <div class="rowStyle" title="{{row[col.field]}}">{{row[col.field]}}</div>
              </ng-template>
            </p-column>
            <p-column
              field="acknowledged"
              header="Acked"
              styleClass="columnStyle"
              [style]="{'width':'80px'}"
            >
              <ng-template let-col let-row="rowData" pTemplate="body">
                <div class="rowStyle" title="{{row[col.field]}}">{{row[col.field]}}</div>
              </ng-template>
            </p-column>
          </p-dataTable>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
  <div class="divider"></div>
  <div class="popup-footer deal__details__footer">
    <button
      pButton
      class="bfx-button-secondary-moderate pull-right bfx-button-sm"
      (click)="close($event)"
    >
      Close
    </button>
  </div>
</div>
